import React, { Component } from 'react';
import Item from '../item';
import { NoContent } from '../../ui';

export default class extends Component {
    render() {
        const { data, onItemClick, onItemDoubleClick } = this.props;

        return (
            <div className="user-list">
              {
                  data.map((item, index)=>{
                      return (
                        <Item data={item} onClick={onItemClick} onDoubleClick={onItemDoubleClick}/>
                      )
                  })
              }
              { data.length ? null: <NoContent text="暂无同事"/> }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/user/list/index.js